import React from 'react';

import { Accordion } from '@/components/ui/accordion';
import { Place } from '@/types';

interface BestOfFAQsProps {
  category: string;
  topPlace: Place;
  places: Place[];
}

export default function BestOfFAQs({ category, topPlace, places }: BestOfFAQsProps) {
  // Ensure we have data to work with
  const placesArray = Array.isArray(places) && places.length > 0 ? places : [];
  const topPlaceName = topPlace?.name || `Top ${category}`;
  const topPlaceLocation = topPlace?.destination || 'various locations';
  const topPlaceFamousFor = topPlace?.famous_for
    ? Array.isArray(topPlace.famous_for)
      ? topPlace.famous_for.join(', ')
      : topPlace.famous_for
    : 'its unique features';

  // List of top 10 places (or however many we have)
  const top10Places = placesArray
    .slice(0, 10)
    .map(place => place.name || 'Unnamed place')
    .join(', ');

  const faqs = [
    {
      title: `What is the main popular ${category} in the world?`,
      content: `Based on our current rankings, the most popular ${category} in the world is ${topPlaceName} located in ${topPlaceLocation}.`,
    },
    {
      title: `What are the top 10 ${category} in the world?`,
      content:
        placesArray.length > 0
          ? `Our current top 10 ${category} list includes: ${top10Places}.`
          : `Our ${category} rankings are being updated. Check back soon for the latest top 10 list.`,
    },
    {
      title: `What makes a ${category} popular?`,
      content: `A ${category}'s popularity is determined by various factors including visitor reviews, ratings, historical significance, unique features, and overall visitor experience. ${topPlaceName} is particularly known for ${topPlaceFamousFor}.`,
    },
  ];

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.title,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.content,
      },
    })),
  };

  return (
    <div className="mt-12">
      <h2 className="text-2xl font-bold mb-6">Frequently Asked Questions</h2>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <Accordion items={faqs} />
    </div>
  );
}
